import React, { Fragment, useContext } from 'react';
import { IoMdArrowBack } from 'react-icons/io';
import { useHistory, useLocation } from 'react-router-dom';
import Input from './forms/Input';
import { FaSearch } from 'react-icons/fa';
import { ProductContext } from '../context/ProductContext';
import { AppContext } from '../context/appData';
import { Analytics } from '../utils/Analytics';

const headerPages = ['/store'];

const Header = props => {
  const appData = useContext(AppContext);
  const productData = useContext(ProductContext);
  const history = useHistory();
  const location = useLocation();
  const onSearchChange = e => {
    productData.setSearchValue(e.target.value);
  };

  const handleSearch = e => {
    e.preventDefault();
    productData.setShowSearchResult(true);
    productData.setProductPageNumber(1);
    productData.setFilters({
      ...productData.filters,
      SearchKeyword: productData.searchValue,
      PageIndex: 1,
    });
    Analytics.logEvent({
      eventName: 'SEARCH_BY_KEYWORD',
      eventData: { searchedKeyword: productData.searchValue },
    });
  };

  return (
    <Fragment>
      <header className="app__header no-print">
        <div className="app__header__content">
          {headerPages.includes(location.pathname) ? (
            <>
              <div className="app__header__content__left">
                <img src="Images/omni.png" alt="omnibiz_logo" />
              </div>

              <div className="app__header__content__right">
                <form onSubmit={handleSearch}>
                  <Input
                    value={productData.searchValue}
                    onChange={onSearchChange}
                    withMargin={true}
                    placeholder={'Search products'}
                    borderRadius={'30px'}
                  />

                  <div
                    style={{ background: appData.theme.color }}
                    className="app__header__content__right__icon pointer"
                    onClick={handleSearch}
                  >
                    <FaSearch color={'#fff'} />
                  </div>
                </form>
              </div>
            </>
          ) : (
            <div className="app__header__content__left">
              <span
                onClick={() => history.push(props.prevPage)}
                className="back__icon pr-5 pointer"
              >
                {props.title && props.prevPage && (
                  <div className="mr-5">
                    <IoMdArrowBack size={'22px'} color={appData.theme.color} />
                  </div>
                )}
              </span>
              <div
                className="font-weight-500 font-size-16"
                style={{ marginTop: '-3px' }}
              >
                {props.title}{' '}
              </div>
            </div>
          )}
        </div>
      </header>
    </Fragment>
  );
};

export default Header;
